import medals_en from '@/assets/data/medals_en.json'
import medals_fr from '@/assets/data/medals_fr.json'


const MedalsService = {

    /**
     * Retrieve all of Medals
     * @param {*} lang The language, either `en` or `fr`
     */
    all(lang) {
        switch(lang) {
            case 'en':
                return medals_en
            case 'fr':
                return medals_fr
            default:
                return null
        }
    },

    /**
     * All search tokens for the API are in English regardless of the selected
     * language. This method returns the English search token based on the ID
     * of the medal.
     * @param {*} id
     */
    search_token_by_id(id) {
        let name = ""
        medals_en.forEach(item => {
            if(item.id === id) {
                name = item.name
            }
        });
        return name
    }
};

export default MedalsService;
